import React from 'react';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, IconButton, CircularProgress, Typography, InputLabel, Input, FormControl, FormHelperText } from '@material-ui/core';
import { IdentityActions, AccountActions } from '../../../store';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        backgroundColor: '#199094', padding: '15px 50px', color: '#fff', fontSize: 24, marginBottom: 0
    },
    title: {
        alignSelf: 'center',

    },
})

class AccountInfo extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        isLoading: false,
        fields: { username: '', name: '', role_name: '' },
    }
    componentDidMount() {
        this.initLoadAccount();
    }
    componentDidUpdate(previousProps, previousState) {
        if (previousProps.open === false && this.props.open === true) {
            this.initLoadAccount();
        }

    }
    initLoadAccount() {
        const token = this.props.auth.token
        //console.log('token=' + token);      

        this.setState({ isLoading: true });
        this.props.getMe(token).then((data) => {
            this.setState({
                isLoading: false,
                fields: { username: data.username ? data.username : '', name: data.name ? data.name : '', role_name: data.role_name ? data.role_name : '' }
            });
            //console.log('data=' + data);            
        });
    }

    handleCancel() {
        this.props.onClose();
    }

    render() {
        const { classes, open } = this.props;
        return (
            <Dialog
                open={open}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth="true"
                maxWidth="sm"
                id="Dialog"
            >
                <DialogTitle id="simple-dialog-title" className={classes.title}>
                    <FormattedMessage className={classes.header} id="Account.Title" />
                </DialogTitle>

                <DialogContent>
                    <form className={classes.form} >
                        <FormControl margin="normal" fullWidth>
                            <InputLabel><FormattedMessage id="Account.Username" /></InputLabel>
                            <Input name="Username" type="text" value={this.state.fields["username"]} readonly="readonly" />
                        </FormControl>
                        <FormControl margin="normal" fullWidth >
                            <InputLabel ><FormattedMessage id="Account.Name" /></InputLabel>
                            <Input name="Name" type="text" value={this.state.fields["name"]} readonly="readonly" />
                        </FormControl>
                        <FormControl margin="normal" fullWidth >
                            <InputLabel ><FormattedMessage id="Account.Role" /></InputLabel>
                            <Input name="RoleName" type="text" value={this.state.fields["role_name"]} readonly="readonly" />
                        </FormControl>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handleCancel()}>
                        <FormattedMessage id="App.AccountClose" />
                    </Button>
                </DialogActions>
            </Dialog>

        );
    }
}

function mapStateToProps(state, ownProps) {

    return {
        //accountInfo: state.Account.AccountInfo,
        auth: state.Identity.auth,
        username: state.Identity.username
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, IdentityActions, AccountActions), dispatch)
}

export default injectIntl(compose(withStyles(styles, { withTheme: true }), connect(
    mapStateToProps,
    mapDispatchToProps
))(AccountInfo));
